import { Field, JsonParseError, JsonParseErrorCode, Regexp } from "sparkson";

export class AnalyticsEndpoint {
  constructor(
    @Field("pr") @Regexp(/^(GA|vintom)$/) public provider: "GA" | "vintom",
    @Field("st", true) public gaServiceTracker?: string,
    @Field("vs", true) public vintomServer?: string,
  ) {
    this.validate();
  }

  private validate() {
    if (this.provider === "GA" && !this.gaServiceTracker) {
      throw new JsonParseError("Google Analytics endpoint has to have gaServiceTracker defined", JsonParseErrorCode.VALIDATION_FAILED);
    }
    if (this.provider === "vintom" && !this.vintomServer) {
      throw new JsonParseError("Vintom Analytics endpoint has to have vintomServer defined", JsonParseErrorCode.VALIDATION_FAILED);
    }
  }
}
